import { useCallback, useState } from 'react'

export const useGlobalCommandView = () => {
  const [initialQuery, setInitialQuery] = useState<Nullable<string>>(null)

  const startConversation = useCallback((query: string) => {
    setInitialQuery(query)
  }, [])

  const endConversation = useCallback(() => {
    setInitialQuery(null)
  }, [])

  return {
    data: { initialQuery },
    methods: { startConversation, endConversation },
  }
}
